import {PostChangeAddressRequest} from 'domain/usecases';
import {makePostChangeAddress} from 'main/factories/usecases';

export async function postChangeAddress(params: PostChangeAddressRequest) {
	await makePostChangeAddress().post(params);

	return params;
}
